import { upsProblems } from './ups-problems.js'

// Curated related services. Keep every public service covered by incoming and outgoing links.
export const serviceLinkMatrix = {
  ...Object.fromEntries(
    upsProblems.map((problem) => [
      problem.path,
      [{ href: '/ups', label: 'UPS Digital Connections' }, ...problem.relatedServices],
    ]),
  ),
  "/web-design": [
    { href: '/ecommerce-website-audit', label: 'Ecommerce Website Audit' },

    { href: '/bigcommerce-to-shopify', label: 'BigCommerce to Shopify' },
    { href: '/seo', label: 'Ecommerce SEO' },
    { href: '/website-speed-optimization', label: 'Website Speed Optimization' },
    { href: '/vip-support', label: 'Ecommerce Support' },
    { href: '/case-study/plant-factory-direct', label: 'Ecommerce Migration Case Study' },
    { "href": "/tampa", "label": "Tampa Web Design" },
    {
      "href": "/shopify",
      "label": "Shopify"
    },
    {
      "href": "/bigcommerce",
      "label": "BigCommerce Development"
    },
    {
      "href": "/ecommerce-website-redesign",
      "label": "Ecommerce Redesign"
    },
    {
      "href": "/b2b-ecommerce-agency",
      "label": "B2B Ecommerce"
    },
    {
      "href": "/conversion-rate-optimization",
      "label": "Conversion Rate Optimization"
    },
    {
      "href": "/ecommerce-consulting",
      "label": "Ecommerce Consulting"
    }
  ],
  "/shopify": [
    { href: '/woocommerce-to-shopify-migration', label: 'WooCommerce to Shopify Migration' },
    { href: '/ecommerce-data-migration-services', label: 'Ecommerce Data Migration' },
    { href: '/b2b-ecommerce-agency', label: 'B2B Ecommerce' },

    {
      "href": "/shopify-theme-customization",
      "label": "Shopify Development"
    },
    {
      "href": "/bigcommerce-to-shopify",
      "label": "BigCommerce to Shopify"
    },
    {
      "href": "/shopify-seo",
      "label": "Shopify SEO"
    },
    {
      "href": "/shopify-support-maintenance",
      "label": "Shopify Support"
    },
    {
      "href": "/klaviyo-email-marketing-agency",
      "label": "Klaviyo Management"
    },
    {
      "href": "/web-design",
      "label": "Web Design"
    },
    {
      "href": "/bigcommerce",
      "label": "BigCommerce Agency"
    },
    {
      "href": "/conversion-rate-optimization",
      "label": "Conversion Rate Optimization"
    },
    {
      "href": "/vip-support",
      "label": "Shopify Maintenance and Support"
    },
    {
      "href": "/case-study/plant-factory-direct",
      "label": "Shopify Migration Case Study"
    }
  ],
  "/bigcommerce": [
    { href: '/b2b-ecommerce-agency', label: 'B2B Ecommerce' },

    {
      "href": "/woocommerce-to-shopify-migration",
      "label": "WooCommerce to Shopify"
    },
    {
      "href": "/bigcommerce-seo",
      "label": "BigCommerce SEO"
    },
    {
      "href": "/bigcommerce-support-maintenance",
      "label": "BigCommerce Support"
    },
    {
      "href": "/ecommerce-data-migration-services",
      "label": "Ecommerce Migration"
    },
    {
      "href": "/conversion-rate-optimization",
      "label": "Conversion Rate Optimization"
    },
    {
      "href": "/web-design",
      "label": "Web Design"
    },
    {
      "href": "/shopify",
      "label": "Shopify Agency"
    },
    {
      "href": "/bigcommerce-to-shopify",
      "label": "BigCommerce to Shopify Migration"
    },
    {
      "href": "/vip-support",
      "label": "BigCommerce Maintenance and Support"
    },
    {
      "href": "/case-study/plant-factory-direct",
      "label": "BigCommerce Migration Case Study"
    }
  ],
  "/ecommerce-website-redesign": [
    {
      "href": "/web-design",
      "label": "Web Design"
    },
    {
      "href": "/shopify-theme-customization",
      "label": "Shopify Development"
    },
    {
      "href": "/conversion-rate-optimization",
      "label": "Conversion Rate Optimization"
    },
    {
      "href": "/website-speed-optimization",
      "label": "Website Speed Optimization"
    },
    {
      "href": "/ecommerce-website-audit",
      "label": "Ecommerce Audit"
    },
    {
      "href": "/ecommerce-website-maintenance",
      "label": "Website Maintenance"
    }
  ],
  "/shopify-theme-customization": [
    {
      "href": "/shopify",
      "label": "Shopify"
    },
    {
      "href": "/ecommerce-website-redesign",
      "label": "Ecommerce Redesign"
    },
    {
      "href": "/shopify-support-maintenance",
      "label": "Shopify Support"
    },
    {
      "href": "/conversion-rate-optimization",
      "label": "Conversion Rate Optimization"
    },
    {
      "href": "/website-speed-optimization",
      "label": "Website Speed Optimization"
    },
    {
      "href": "/ada-accessibility-optimization",
      "label": "ADA Accessibility Optimization"
    }
  ],
  "/tampa": [
    {
      "href": "/web-design",
      "label": "Web Design"
    },
    {
      "href": "/shopify",
      "label": "Shopify"
    },
    {
      "href": "/seo",
      "label": "SEO"
    },
    {
      "href": "/paid-search",
      "label": "Google Ads"
    },
    {
      "href": "/ecommerce-consulting",
      "label": "Ecommerce Consulting"
    },
    {
      "href": "/vip-support",
      "label": "VIP Support"
    }
  ],
  "/bigcommerce-to-shopify": [
    { href: '/woocommerce-to-shopify-migration', label: 'WooCommerce to Shopify Migration' },

    {
      "href": "/shopify",
      "label": "Shopify"
    },
    {
      "href": "/ecommerce-data-migration-services",
      "label": "Ecommerce Migration"
    },
    {
      "href": "/shopify-theme-customization",
      "label": "Shopify Development"
    },
    {
      "href": "/shopify-seo",
      "label": "Shopify SEO"
    },
    {
      "href": "/shopify-support-maintenance",
      "label": "Shopify Support"
    },
    {
      "href": "/ecommerce-consulting",
      "label": "Ecommerce Consulting"
    },
    {
      "href": "/bigcommerce",
      "label": "BigCommerce Agency"
    },
    {
      "href": "/web-design",
      "label": "Ecommerce Web Design"
    },
    {
      "href": "/conversion-rate-optimization",
      "label": "Conversion Rate Optimization"
    },
    {
      "href": "/vip-support",
      "label": "Post-Launch Shopify Maintenance"
    },
    {
      "href": "/case-study/plant-factory-direct",
      "label": "BigCommerce to Shopify Case Study"
    }
  ],
  "/woocommerce-to-shopify-migration": [
    {
      "href": "/shopify",
      "label": "Shopify"
    },
    {
      "href": "/ecommerce-data-migration-services",
      "label": "Ecommerce Migration"
    },
    {
      "href": "/shopify-theme-customization",
      "label": "Shopify Development"
    },
    {
      "href": "/shopify-seo",
      "label": "Shopify SEO"
    },
    {
      "href": "/shopify-support-maintenance",
      "label": "Shopify Support"
    },
    {
      "href": "/ecommerce-website-audit",
      "label": "Ecommerce Audit"
    }
  ],
  "/ecommerce-data-migration-services": [
    {
      "href": "/bigcommerce-to-shopify",
      "label": "BigCommerce to Shopify"
    },
    {
      "href": "/woocommerce-to-shopify-migration",
      "label": "WooCommerce to Shopify"
    },
    {
      "href": "/b2b-ecommerce-agency",
      "label": "B2B Ecommerce"
    },
    {
      "href": "/ecommerce-consulting",
      "label": "Ecommerce Consulting"
    },
    {
      "href": "/ecommerce-website-audit",
      "label": "Ecommerce Audit"
    },
    {
      "href": "/ecommerce-website-redesign",
      "label": "Ecommerce Redesign"
    }
  ],
  "/b2b-ecommerce-agency": [
    {
      "href": "/web-design",
      "label": "Web Design"
    },
    {
      "href": "/shopify",
      "label": "Shopify"
    },
    {
      "href": "/bigcommerce",
      "label": "BigCommerce Development"
    },
    {
      "href": "/ecommerce-data-migration-services",
      "label": "Ecommerce Migration"
    },
    {
      "href": "/ecommerce-consulting",
      "label": "Ecommerce Consulting"
    },
    {
      "href": "/ecommerce-website-audit",
      "label": "Ecommerce Audit"
    }
  ],
  "/seo": [
    {
      "href": "/shopify-seo",
      "label": "Shopify SEO"
    },
    {
      "href": "/bigcommerce-seo",
      "label": "BigCommerce SEO"
    },
    {
      "href": "/ecommerce-seo-audit",
      "label": "Ecommerce SEO Audit"
    },
    {
      "href": "/ai-optimization",
      "label": "AI Optimization"
    },
    {
      "href": "/conversion-rate-optimization",
      "label": "Conversion Rate Optimization"
    },
    {
      "href": "/website-speed-optimization",
      "label": "Website Speed Optimization"
    },
    {
      "href": "/shopify",
      "label": "Shopify Agency"
    },
    {
      "href": "/bigcommerce",
      "label": "BigCommerce Agency"
    },
    {
      "href": "/bigcommerce-to-shopify",
      "label": "SEO-Safe Platform Migration"
    },
    {
      "href": "/case-study/plant-factory-direct",
      "label": "Ecommerce Migration Case Study"
    }
  ],
  "/shopify-seo": [
    {
      "href": "/shopify",
      "label": "Shopify"
    },
    {
      "href": "/shopify-theme-customization",
      "label": "Shopify Development"
    },
    {
      "href": "/ecommerce-seo-audit",
      "label": "Ecommerce SEO Audit"
    },
    {
      "href": "/ai-optimization",
      "label": "AI Optimization"
    },
    {
      "href": "/shopify-support-maintenance",
      "label": "Shopify Support"
    },
    {
      "href": "/seo",
      "label": "SEO"
    }
  ],
  "/bigcommerce-seo": [
    {
      "href": "/bigcommerce",
      "label": "BigCommerce Development"
    },
    {
      "href": "/ecommerce-seo-audit",
      "label": "Ecommerce SEO Audit"
    },
    {
      "href": "/ai-optimization",
      "label": "AI Optimization"
    },
    {
      "href": "/bigcommerce-support-maintenance",
      "label": "BigCommerce Support"
    },
    {
      "href": "/website-speed-optimization",
      "label": "Website Speed Optimization"
    },
    {
      "href": "/seo",
      "label": "SEO"
    }
  ],
  "/ecommerce-seo-audit": [
    {
      "href": "/seo",
      "label": "SEO"
    },
    {
      "href": "/shopify-seo",
      "label": "Shopify SEO"
    },
    {
      "href": "/bigcommerce-seo",
      "label": "BigCommerce SEO"
    },
    {
      "href": "/ai-optimization",
      "label": "AI Optimization"
    },
    {
      "href": "/website-speed-optimization",
      "label": "Website Speed Optimization"
    },
    {
      "href": "/ecommerce-website-audit",
      "label": "Ecommerce Audit"
    }
  ],
  "/ai-optimization": [
    {
      "href": "/seo",
      "label": "SEO"
    },
    {
      "href": "/ecommerce-seo-audit",
      "label": "Ecommerce SEO Audit"
    },
    {
      "href": "/shopify-seo",
      "label": "Shopify SEO"
    },
    {
      "href": "/bigcommerce-seo",
      "label": "BigCommerce SEO"
    },
    {
      "href": "/ecommerce-consulting",
      "label": "Ecommerce Consulting"
    },
    {
      "href": "/ecommerce-website-audit",
      "label": "Ecommerce Audit"
    },
    {
      "href": "/shopify",
      "label": "Shopify Agency"
    },
    {
      "href": "/bigcommerce",
      "label": "BigCommerce Agency"
    },
    {
      "href": "/website-speed-optimization",
      "label": "Website Speed Audit and Optimization"
    },
    {
      "href": "/conversion-rate-optimization",
      "label": "Conversion Rate Optimization"
    },
    {
      "href": "/vip-support",
      "label": "Ecommerce Maintenance and Support"
    }
  ],
  "/paid-search": [
    {
      "href": "/google-shopping-management",
      "label": "Google Shopping"
    },
    {
      "href": "/google-merchant-center-services",
      "label": "Google Merchant Center"
    },
    {
      "href": "/social-media-marketing",
      "label": "Social Media Marketing"
    },
    {
      "href": "/conversion-rate-optimization",
      "label": "Conversion Rate Optimization"
    },
    {
      "href": "/email-marketing",
      "label": "Email Marketing"
    },
    {
      "href": "/ecommerce-consulting",
      "label": "Ecommerce Consulting"
    }
  ],
  "/google-shopping-management": [
    {
      "href": "/paid-search",
      "label": "Google Ads"
    },
    {
      "href": "/google-merchant-center-services",
      "label": "Google Merchant Center"
    },
    {
      "href": "/conversion-rate-optimization",
      "label": "Conversion Rate Optimization"
    },
    {
      "href": "/ecommerce-seo-audit",
      "label": "Ecommerce SEO Audit"
    },
    {
      "href": "/klaviyo-email-marketing-agency",
      "label": "Klaviyo Management"
    },
    {
      "href": "/ecommerce-consulting",
      "label": "Ecommerce Consulting"
    }
  ],
  "/google-merchant-center-services": [
    {
      "href": "/google-shopping-management",
      "label": "Google Shopping"
    },
    {
      "href": "/paid-search",
      "label": "Google Ads"
    },
    {
      "href": "/ecommerce-data-migration-services",
      "label": "Ecommerce Migration"
    },
    {
      "href": "/ecommerce-website-maintenance",
      "label": "Website Maintenance"
    },
    {
      "href": "/ecommerce-seo-audit",
      "label": "Ecommerce SEO Audit"
    },
    {
      "href": "/ecommerce-consulting",
      "label": "Ecommerce Consulting"
    }
  ],
  "/social-media-marketing": [
    {
      "href": "/paid-search",
      "label": "Google Ads"
    },
    {
      "href": "/email-marketing",
      "label": "Email Marketing"
    },
    {
      "href": "/klaviyo-email-marketing-agency",
      "label": "Klaviyo Management"
    },
    {
      "href": "/conversion-rate-optimization",
      "label": "Conversion Rate Optimization"
    },
    {
      "href": "/ecommerce-website-redesign",
      "label": "Ecommerce Redesign"
    },
    {
      "href": "/ecommerce-consulting",
      "label": "Ecommerce Consulting"
    }
  ],
  "/conversion-rate-optimization": [
    {
      "href": "/ecommerce-website-redesign",
      "label": "Ecommerce Redesign"
    },
    {
      "href": "/website-speed-optimization",
      "label": "Website Speed Optimization"
    },
    {
      "href": "/ada-accessibility-optimization",
      "label": "ADA Accessibility Optimization"
    },
    {
      "href": "/paid-search",
      "label": "Google Ads"
    },
    {
      "href": "/email-marketing",
      "label": "Email Marketing"
    },
    {
      "href": "/ecommerce-website-audit",
      "label": "Ecommerce Audit"
    },
    {
      "href": "/web-design",
      "label": "Ecommerce Web Design"
    },
    {
      "href": "/shopify",
      "label": "Shopify Agency"
    },
    {
      "href": "/bigcommerce",
      "label": "BigCommerce Agency"
    },
    {
      "href": "/bigcommerce-to-shopify",
      "label": "BigCommerce to Shopify Migration"
    },
    {
      "href": "/vip-support",
      "label": "Ecommerce Maintenance and Support"
    },
    {
      "href": "/case-study/plant-factory-direct",
      "label": "Ecommerce Migration Case Study"
    }
  ],
  "/email-marketing": [
    {
      "href": "/klaviyo-email-marketing-agency",
      "label": "Klaviyo Management"
    },
    {
      "href": "/social-media-marketing",
      "label": "Social Media Marketing"
    },
    {
      "href": "/conversion-rate-optimization",
      "label": "Conversion Rate Optimization"
    },
    {
      "href": "/vip-support",
      "label": "VIP Support"
    },
    {
      "href": "/ecommerce-consulting",
      "label": "Ecommerce Consulting"
    },
    {
      "href": "/paid-search",
      "label": "Google Ads"
    }
  ],
  "/mailchimp-to-klaviyo-migration": [
    { href: '/klaviyo-email-marketing-agency', label: 'Klaviyo Management' },
    { href: '/email-marketing', label: 'Email Marketing' },
    { href: '/shopify', label: 'Shopify' },
    { href: '/bigcommerce', label: 'BigCommerce Development' },
  ],
  "/klaviyo-email-marketing-agency": [
    { href: '/mailchimp-to-klaviyo-migration', label: 'Mailchimp to Klaviyo Migration' },
    {
      "href": "/email-marketing",
      "label": "Email Marketing"
    },
    {
      "href": "/shopify",
      "label": "Shopify"
    },
    {
      "href": "/bigcommerce",
      "label": "BigCommerce Development"
    },
    {
      "href": "/conversion-rate-optimization",
      "label": "Conversion Rate Optimization"
    },
    {
      "href": "/vip-support",
      "label": "VIP Support"
    },
    {
      "href": "/ecommerce-website-maintenance",
      "label": "Website Maintenance"
    }
  ],
  "/ecommerce-website-maintenance": [
    {
      "href": "/shopify-support-maintenance",
      "label": "Shopify Support"
    },
    {
      "href": "/bigcommerce-support-maintenance",
      "label": "BigCommerce Support"
    },
    {
      "href": "/vip-support",
      "label": "VIP Support"
    },
    {
      "href": "/website-speed-optimization",
      "label": "Website Speed Optimization"
    },
    {
      "href": "/ada-accessibility-optimization",
      "label": "ADA Accessibility Optimization"
    },
    {
      "href": "/ecommerce-website-audit",
      "label": "Ecommerce Audit"
    }
  ],
  "/shopify-support-maintenance": [
    {
      "href": "/shopify",
      "label": "Shopify"
    },
    {
      "href": "/shopify-theme-customization",
      "label": "Shopify Development"
    },
    {
      "href": "/shopify-seo",
      "label": "Shopify SEO"
    },
    {
      "href": "/ecommerce-website-maintenance",
      "label": "Website Maintenance"
    },
    {
      "href": "/vip-support",
      "label": "VIP Support"
    },
    {
      "href": "/website-speed-optimization",
      "label": "Website Speed Optimization"
    }
  ],
  "/bigcommerce-support-maintenance": [
    {
      "href": "/bigcommerce",
      "label": "BigCommerce Development"
    },
    {
      "href": "/bigcommerce-seo",
      "label": "BigCommerce SEO"
    },
    {
      "href": "/ecommerce-website-maintenance",
      "label": "Website Maintenance"
    },
    {
      "href": "/vip-support",
      "label": "VIP Support"
    },
    {
      "href": "/website-speed-optimization",
      "label": "Website Speed Optimization"
    },
    {
      "href": "/ada-accessibility-optimization",
      "label": "ADA Accessibility Optimization"
    }
  ],
  "/vip-support": [
    {
      "href": "/ecommerce-website-maintenance",
      "label": "Website Maintenance"
    },
    {
      "href": "/shopify-support-maintenance",
      "label": "Shopify Support"
    },
    {
      "href": "/bigcommerce-support-maintenance",
      "label": "BigCommerce Support"
    },
    {
      "href": "/email-marketing",
      "label": "Email Marketing"
    },
    {
      "href": "/klaviyo-email-marketing-agency",
      "label": "Klaviyo Management"
    },
    {
      "href": "/ecommerce-consulting",
      "label": "Ecommerce Consulting"
    },
    {
      "href": "/web-design",
      "label": "Ecommerce Web Design"
    },
    {
      "href": "/shopify",
      "label": "Shopify Agency"
    },
    {
      "href": "/bigcommerce",
      "label": "BigCommerce Agency"
    },
    {
      "href": "/conversion-rate-optimization",
      "label": "Conversion Rate Optimization"
    },
    {
      "href": "/website-speed-optimization",
      "label": "Website Speed Optimization"
    },
    {
      "href": "/case-study/plant-factory-direct",
      "label": "Ongoing Ecommerce Support Case Study"
    }
  ],
  "/website-speed-optimization": [
    {
      "href": "/ecommerce-website-maintenance",
      "label": "Website Maintenance"
    },
    {
      "href": "/shopify-support-maintenance",
      "label": "Shopify Support"
    },
    {
      "href": "/bigcommerce-support-maintenance",
      "label": "BigCommerce Support"
    },
    {
      "href": "/conversion-rate-optimization",
      "label": "Conversion Rate Optimization"
    },
    {
      "href": "/seo",
      "label": "SEO"
    },
    {
      "href": "/ada-accessibility-optimization",
      "label": "ADA Accessibility Optimization"
    },
    {
      "href": "/shopify",
      "label": "Shopify Agency"
    },
    {
      "href": "/bigcommerce",
      "label": "BigCommerce Agency"
    },
    {
      "href": "/bigcommerce-to-shopify",
      "label": "BigCommerce to Shopify Migration"
    },
    {
      "href": "/vip-support",
      "label": "Ecommerce Maintenance and Support"
    }
  ],
  "/ada-accessibility-optimization": [
    {
      "href": "/web-design",
      "label": "Web Design"
    },
    {
      "href": "/ecommerce-website-redesign",
      "label": "Ecommerce Redesign"
    },
    {
      "href": "/conversion-rate-optimization",
      "label": "Conversion Rate Optimization"
    },
    {
      "href": "/ecommerce-website-maintenance",
      "label": "Website Maintenance"
    },
    {
      "href": "/website-speed-optimization",
      "label": "Website Speed Optimization"
    },
    {
      "href": "/ecommerce-website-audit",
      "label": "Ecommerce Audit"
    },
    {
      "href": "/shopify",
      "label": "Shopify Agency"
    },
    {
      "href": "/bigcommerce",
      "label": "BigCommerce Agency"
    },
    {
      "href": "/vip-support",
      "label": "Ecommerce Maintenance and Support"
    }
  ],
  "/ecommerce-consulting": [
    {
      "href": "/b2b-ecommerce-agency",
      "label": "B2B Ecommerce"
    },
    {
      "href": "/ecommerce-website-redesign",
      "label": "Ecommerce Redesign"
    },
    {
      "href": "/ecommerce-data-migration-services",
      "label": "Ecommerce Migration"
    },
    {
      "href": "/paid-search",
      "label": "Google Ads"
    },
    {
      "href": "/vip-support",
      "label": "VIP Support"
    },
    {
      "href": "/ecommerce-website-audit",
      "label": "Ecommerce Audit"
    }
  ],
  "/ecommerce-website-audit": [
    {
      "href": "/ecommerce-website-redesign",
      "label": "Ecommerce Redesign"
    },
    {
      "href": "/ecommerce-seo-audit",
      "label": "Ecommerce SEO Audit"
    },
    {
      "href": "/conversion-rate-optimization",
      "label": "Conversion Rate Optimization"
    },
    {
      "href": "/ecommerce-website-maintenance",
      "label": "Website Maintenance"
    },
    {
      "href": "/ada-accessibility-optimization",
      "label": "ADA Accessibility Optimization"
    },
    {
      "href": "/ecommerce-consulting",
      "label": "Ecommerce Consulting"
    }
  ]
}
